import React from "react";
import { Box, Grid } from "@mui/material";
import { observer } from "mobx-react-lite";
import user from "../../../Mobx/User";

import ExistsImageSection from "./ExistsImageSection";
import ExistsSentenceSection from "./ExistsSentenceSection";
import ExistsDefinitionSection from "./ExistsDefinitionSection";
import ExistsStorySection from "./ExistsStorySection";
import ExistsDistractingForTrnsSection from "./ExistsDistractingForTrnsSection";
import ExistsDistractingForOriginalSection from "./ExistsDistractingForOriginalSection";
import ExistsExistsOppositesSection from "./ExistsOppositesSection";
import ExistsSynonymsSection from "./ExistsSynonymsSection";
import ExistsSentencesWithMissingSection from "./ExistsSentencesWithMissingSection";
import ExistsSentencesWithLastMissingSection from "./ExistsSentencesWithLastMissingSection";
import ExistsDistractingForDefinitionInEngSection from "./ExistsDistractingForDefinitionInEngSection";
import ExistsDistractingForDefinitionInHebSection from "./ExistsDistractingForDefinitionInHebSection";
import ExistsDistractingForWordFamiliesSection from "./ExistsDistractingForWordFamiliesSection";
import ExistsTrnsArSection from "./ExistsTrnsArSection";
import ExistsTrnsRuSection from "./ExistsTrnsRuSection";

import additionalInfo from "../../../Mobx/AdditionalInfo";

const ExistsInfo = observer(() => {

    const headerHeight = 104;
    const height = `calc(100vh - ${headerHeight}px)`;

    const sectionsToShow = additionalInfo.sectionsToShow || [];

    return (
        <Box
            sx={{
                height,
                overflowY: "auto",
                overflowX: "hidden",
                pt: 0.5,
                px: 0,
                pb: 0.5,
                direction: "rtl",
                bgcolor: "#f9f9f9",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
            }}
        >
            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", direction: "ltr" }}>
                {user.limitedAdmin.includes(user.email) ?
                    <Grid container spacing={0.5} justifyContent="center" sx={{ width: "100%" }}>
                        {sectionsToShow.includes("images") && <ExistsImageSection />}
                        {/* {sectionsToShow.includes("sentences") && <ExistsSentenceSection />}
                        {sectionsToShow.includes("definitions") && <ExistsDefinitionSection />}
                        {sectionsToShow.includes("stories") && <ExistsStorySection />} */}
                        {/* {sectionsToShow.includes("trnsAr") && <ExistsTrnsArSection />} */}
                        {/* {sectionsToShow.includes("trnsRu") && <ExistsTrnsRuSection />} */}
                        {sectionsToShow.includes("distractingForTrns") && <ExistsDistractingForTrnsSection />}
                        {sectionsToShow.includes("distractingForOriginal") && <ExistsDistractingForOriginalSection />}
                        {/* {sectionsToShow.includes("distractingForDefinitionInEng") && <ExistsDistractingForDefinitionInEngSection />}
                        {sectionsToShow.includes("distractingForDefinitionInHeb") && <ExistsDistractingForDefinitionInHebSection />} */}
                        {/* {sectionsToShow.includes("distractingForWordFamilies") && <ExistsDistractingForWordFamiliesSection />} */}
                        {/* {sectionsToShow.includes("sentencesWithMissing") && <ExistsSentencesWithMissingSection />}
                        {sectionsToShow.includes("sentencesWithLastMissing") && <ExistsSentencesWithLastMissingSection />}
                        {sectionsToShow.includes("opposites") && <ExistsExistsOppositesSection />}
                        {sectionsToShow.includes("synonyms") && <ExistsSynonymsSection />} */}
                    </Grid>
                    :
                    <Grid container spacing={0.5} justifyContent="center" sx={{ width: "100%" }}>
                        {sectionsToShow.includes("images") && <ExistsImageSection />}
                        {sectionsToShow.includes("sentences") && <ExistsSentenceSection />}
                        {sectionsToShow.includes("definitions") && <ExistsDefinitionSection />}
                        {sectionsToShow.includes("stories") && <ExistsStorySection />}
                        {sectionsToShow.includes("trnsAr") && <ExistsTrnsArSection />}
                        {sectionsToShow.includes("trnsRu") && <ExistsTrnsRuSection />}
                        {sectionsToShow.includes("distractingForTrns") && <ExistsDistractingForTrnsSection />}
                        {sectionsToShow.includes("distractingForOriginal") && <ExistsDistractingForOriginalSection />}
                        {sectionsToShow.includes("distractingForDefinitionInEng") && <ExistsDistractingForDefinitionInEngSection />}
                        {sectionsToShow.includes("distractingForDefinitionInHeb") && <ExistsDistractingForDefinitionInHebSection />}
                        {sectionsToShow.includes("distractingForWordFamilies") && <ExistsDistractingForWordFamiliesSection />}
                        {sectionsToShow.includes("sentencesWithMissing") && <ExistsSentencesWithMissingSection />}
                        {sectionsToShow.includes("sentencesWithLastMissing") && <ExistsSentencesWithLastMissingSection />}
                        {sectionsToShow.includes("opposites") && <ExistsExistsOppositesSection />}
                        {sectionsToShow.includes("synonyms") && <ExistsSynonymsSection />}
                    </Grid>
                }
            </Box>
        </Box>
    );
});

export default ExistsInfo;
